// removed by extract-text-webpack-plugin
module.exports = {"dotsClass":"_3HaDe8kG-U2d39Qjkozcdr"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/FooterCarousel/FooterCarousel.scss
 ** module id = 970
 ** module chunks = 0
 **/